<template>
  <div>
    <LineChart
      class="chart-body"
      :chart-data="datacollection"
      :options="options">
    </LineChart>
  </div>
</template>

<script>
import Chart from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import LineChart from '@/common/LineChart.js'
import { formatTime } from '@/common/format.js'
import {db} from "@/firebase/db.js"

Chart.plugins.register(ChartDataLabels)
//Chart.defaults.global.hover.animationDuration = 0

function formatTimestamp (ts) {
  //return ts.toDate().toLocaleString('ja-JP')
  const d = ts.toDate()
  return `${d.getFullYear()}/${d.getMonth()+1}/${d.getDate()}`
}

export default {
  components: {
    LineChart
  },
  props: [ 'history' ],
  data() {
    return {
    datacollection: {},
    options: {
      responsive: true,
      maintainAspectRatio: false,
      layout: {
        padding: {
          left: 10,
          right: 40,
          top: 16,
          bottom: 0,
        },
      },
      scales: {
        yAxes: [{
          type: 'logarithmic',
          ticks: {
            callback: function(value, index, values) { // eslint-disable-line
              return formatTime(value)
            },
            autoSkipPadding: 20,
            padding: 22,
          },
        }],
      },
      tooltips: {
        xPadding: 10,
        yPadding: 10,
        callbacks: {
          title: (ti, o) => { // eslint-disable-line
            if (ti.length > 0) {
              return this.datacollection.datasets[0].user[ti[0].index]
            }
          }
        }
      },
      legend: {
        display: false,
      },
      onHover: (e, el) => { // eslint-disable-line
          const target = e.native ? e.native.target : e.target;
          target.style.cursor = el[0] ? 'pointer' : 'default';
      },
      onClick: (e, el) => {
        if (el.length == 0) return
        const path = this.datacollection.datasets[0].link[el[0]._index]
        this.$router.push({ path: path }).catch(() => {})
      },
      plugins: {
        datalabels: {
          align: 'bottom',
          offset: 18,
          backgroundColor: 'rgba(255, 255, 255, 0.7)',
          formatter: function(value, context) { // eslint-disable-line
            return formatTime(value, 2)
          },
          //listeners: {
          //  click: function(context) { // eslint-disable-line
          //    console.log('label ' + context.dataIndex + ' has been clicked!');
          //  },
          //},
        },
      },
      // anti-flicker
      animation: {
        duration: 0,
      },
      hover: {
        animationDuration: 0,
      }
    },
    userIcons: {},
    userNames: {},
    }
  },
  mounted () {
    //const canvas = document.querySelector("#line-chart")
    //console.log(canvas)
    this.fillData()
  },
  methods: {
    async fillData () {
      const data = {
        labels: [],
        datasets: [
          {
            data: [],
            user: [],
            link: [],
            pointStyle: [],
            pointRadius: 18,
            backgroundColor: 'rgba(0, 0, 0, 0.0)',
            borderColor: 'rgba(25, 118, 210, 0.5)',
            lineTension: 0,
          }
        ]
      }

      const bestTime = Infinity
      for (const key in this.history) {
        const record = this.history[key]

        if (record.score >= bestTime) continue

        if (!(record.userId in this.userIcons)) {
          const user = await db.collection("users").doc(record.userId).get()
          const img = new Image()
          const size = 32
          img.src = user.data().photoURL
          const canvas = document.createElement('canvas')
          canvas.width = size
          canvas.height = size

          const ctx = canvas.getContext('2d')
          ctx.save()
          ctx.beginPath()
          ctx.arc(size/2, size/2, size/2, 0, Math.PI * 2, true)
          ctx.closePath()
          ctx.clip()

          ctx.drawImage(img, 0, 0, size, size)

          ctx.beginPath()
          ctx.arc(0, 0, size/2, 0, Math.PI * 2, true)
          ctx.clip()
          ctx.closePath()
          ctx.restore()

          this.userIcons[record.userId] = canvas
          this.userNames[record.userId] = user.data().name
        }

        data.labels.push(formatTimestamp(record.date))
        data.datasets[0].data.push(record.score)
        data.datasets[0].user.push(this.userNames[record.userId])
        data.datasets[0].link.push(`/user/${this.userNames[record.userId]}/code/${record.codeId}`)
        data.datasets[0].pointStyle.push(this.userIcons[record.userId])
      }

      this.datacollection = data
    },
  },
  watch: {
    history: function () {
      this.fillData()
    },
  },
}
</script>

<style>
.chart-body {
  height: 320px;
}
</style>
